import {
    INVOICE_NOTIFIER_ERROR_INVALID_FILE,
    INVOICE_NOTIFIER_ERROR_INVALID_FILE_TYPE,
    INVOICE_NOTIFIER_ERROR_INVALID_FILE_CSV_HEADER,
    INVOICE_NOTIFIER_ERROR_INVALID_WINNING_INVOICE_RECORD,
    INVOICE_NOTIFIER_ERROR_CONFLICT
} from 'constants/invoice-notifier';

const invoiceWinnerNotifier = {
    'document_title': '發票中獎通知',
    'import_info': '請匯入中獎清單 csv 檔案以開始作業',
    'import_invoice_file': '匯入發票 csv 檔案',
    [`import_invoice_error_${ INVOICE_NOTIFIER_ERROR_INVALID_FILE }`]: '無效的匯入檔案，請再嘗試一次',
    [`import_invoice_error_${ INVOICE_NOTIFIER_ERROR_INVALID_FILE_TYPE }`]: '無效的檔案類型，檔案需為 csv 檔',
    [`import_invoice_error_${ INVOICE_NOTIFIER_ERROR_INVALID_FILE_CSV_HEADER }`]: 'CSV 標頭錯誤，請確認標頭為原本 Ezpay 下載的標頭',
    [`import_invoice_error_${ INVOICE_NOTIFIER_ERROR_INVALID_WINNING_INVOICE_RECORD }`]: '無效的中獎發票紀錄，請確保檔案的發票號碼都存在，或請檢查以下發票內容是否正確: %{invoice_number}',
    [`import_invoice_error_${ INVOICE_NOTIFIER_ERROR_CONFLICT }`]: '此中獎發票清單已在執行中',
    'import_success': '你上傳的中獎發票清單已在執行發送中，發送完成後，你將會收到發送結果信件',
};

export default invoiceWinnerNotifier;
